import Image from 'next/image';
import Link from 'next/link';
import React, { FC } from 'react';
import logo from './logoMega.svg';
import { HeaderUser } from './header-user';
import { ShowASideMenuButton } from './show-aside-menu-button';

export const Header: FC = () => {
  const [fantasyName, setFantasyName] = React.useState<string>('');
  const [document, setDocument] = React.useState<string>('');

  React.useEffect(() => {
    const fName = localStorage.getItem('cFantasyName') || '';
    const fDocument = localStorage.getItem('cDocument') || '';
    setFantasyName(fName);
    setDocument(fDocument);
  }, []);

  return (
    <div id="kt_header" className="header align-items-stretch">
      <div className="container-fluid d-flex align-items-stretch justify-content-between">
        <ShowASideMenuButton />
        <div className="d-flex align-items-center flex-grow-1 flex-lg-grow-0">
          <Link href="/" className="px-6">
            <Image src={logo} width={80} height={80} alt="Logo" />
          </Link>
          {`${fantasyName} - ${document.replace(/\D/g, '').replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5')}`}
        </div>
        <div className="d-flex align-items-stretch justify-content-between flex-lg-grow-1">
          <div className="d-flex align-items-stretch" id="kt_header_nav">
            {/* <HeaderMenu /> */}
          </div>
        </div>
        <div className="d-flex align-items-center">
          <HeaderUser />
        </div>
      </div>
    </div>
  );
};
